import { render } from "./Setting.vue?vue&type=template&id=bf4a499e&scoped=true"
const script = {}

import "./Setting.vue?vue&type=style&index=0&id=bf4a499e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf4a499e"]])

export default __exports__